/** LINE profile photo constraints (Official Account Manager). */
export const ICON_ACCEPTED_MIME_TYPES = ['image/png', 'image/jpeg'] as const
export const ICON_ACCEPTED_EXTENSIONS = ['.png', '.jpg', '.jpeg'] as const
export const ICON_ACCEPT_ATTRIBUTE = [
  'image/png',
  'image/jpeg',
  '.png',
  '.jpg',
  '.jpeg',
].join(',')
export const ICON_MAX_BYTES = 3 * 1024 * 1024
export const ICON_RECOMMENDED_WIDTH = 640
export const ICON_RECOMMENDED_HEIGHT = 640

export const isAcceptedIconType = (file: File): boolean => {
  if (
    ICON_ACCEPTED_MIME_TYPES.includes(
      file.type as (typeof ICON_ACCEPTED_MIME_TYPES)[number],
    )
  ) {
    return true
  }
  const lowerName = file.name.toLowerCase()
  return ICON_ACCEPTED_EXTENSIONS.some((ext) => lowerName.endsWith(ext))
}

export const loadImageDimensions = (
  file: File,
): Promise<{ width: number; height: number }> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file)
    const img = new Image()
    img.onload = () => {
      URL.revokeObjectURL(url)
      resolve({ width: img.naturalWidth, height: img.naturalHeight })
    }
    img.onerror = () => {
      URL.revokeObjectURL(url)
      reject(new Error('invalid_image'))
    }
    img.src = url
  })

export const hasRecommendedIconDimensions = (
  width: number,
  height: number,
): boolean =>
  width === ICON_RECOMMENDED_WIDTH && height === ICON_RECOMMENDED_HEIGHT
